export const AG_GRID_LOCALE_RU = {
    // Выбор фильтра
    selectAll: '(Выделить все)',
    selectAllSearchResults: '(Выделить все результаты поиска)',
    addCurrentSelectionToFilter: 'Добавить текущий выбор в фильтр',
    searchOoo: 'Поиск...',
    blanks: '(Пустые)',
    noMatches: 'Нет совпадений',

    // Числовой фильтр и текстовый фильтр
    filterOoo: 'Фильтр...',
    equals: 'Равно',
    notEqual: 'Не равно',
    blank: 'Пусто',
    notBlank: 'Не пусто',
    empty: 'Выберите один',

    // Числовой фильтр
    lessThan: 'Меньше чем',
    greaterThan: 'Больше чем',
    lessThanOrEqual: 'Меньше или равно',
    greaterThanOrEqual: 'Больше или равно',
    inRange: 'Между',
    inRangeStart: 'От',
    inRangeEnd: 'До',

    // Текстовый фильтр
    contains: 'Содержит',
    notContains: 'Не содержит',
    startsWith: 'Начинается с',
    endsWith: 'Кончается на',

    // Фильтр даты
    dateFormatOoo: 'dd.mm.yyyy',
    before: 'До',
    after: 'После',

    // Условия фильтрации
    andCondition: 'И',
    orCondition: 'ИЛИ',

    // Кнопки фильтра
    applyFilter: 'Применить',
    resetFilter: 'Сбросить',
    clearFilter: 'Очистить',
    cancelFilter: 'Отмена',

    // Заголовки фильтров
    textFilter: 'Текстовый фильтр',
    numberFilter: 'Числовой фильтр',
    dateFilter: 'Фильтр по дате',
    setFilter: 'Выбрать фильтр',

    // Фильтр группового столбца
    groupFilterSelect: 'Выбрать поле:',

    // Продвинутый фильтр
    advancedFilterContains: 'содержит',
    advancedFilterNotContains: 'не содержит',
    advancedFilterTextEquals: 'равно',
    advancedFilterTextNotEqual: 'не равно',
    advancedFilterStartsWith: 'начинается с',
    advancedFilterEndsWith: 'заканчивается на',
    advancedFilterBlank: 'пусто',
    advancedFilterNotBlank: 'не пусто',
    advancedFilterEquals: '=',
    advancedFilterNotEqual: '!=',
    advancedFilterGreaterThan: '>',
    advancedFilterGreaterThanOrEqual: '>=',
    advancedFilterLessThan: '<',
    advancedFilterLessThanOrEqual: '<=',
    advancedFilterTrue: 'истина',
    advancedFilterFalse: 'ложь',
    advancedFilterAnd: 'И',
    advancedFilterOr: 'ИЛИ',
    advancedFilterApply: 'Применить',
    advancedFilterBuilder: 'Конструктор',
    advancedFilterValidationMissingColumn: 'Отсутствует столбец',
    advancedFilterValidationMissingOption: 'Отсутствует параметр',
    advancedFilterValidationMissingValue: 'Отсутствует значение',
    advancedFilterValidationInvalidColumn: 'Столбец не найден',
    advancedFilterValidationInvalidOption: 'Параметр не найден',
    advancedFilterValidationMissingQuote: 'Отсутствует закрывающая кавычка',
    advancedFilterValidationNotANumber: 'Значение не является числом',
    advancedFilterValidationInvalidDate: 'Недействительная дата',
    advancedFilterValidationMissingCondition: 'Отсутствует условие',
    advancedFilterValidationJoinOperatorMismatch: 'Операторы объединения внутри условия должны быть одинаковыми',
    advancedFilterValidationInvalidJoinOperator: 'Оператор объединения не найден',
    advancedFilterValidationMissingEndBracket: 'Отсутствует закрывающая скобка',
    advancedFilterValidationExtraEndBracket: 'Лишние закрывающие скобки',
    advancedFilterValidationMessage: 'Ошибка в выражении. ${variable} - ${variable}.',
    advancedFilterValidationMessageAtEnd: 'Ошибка в выражении. ${variable} в конце выражения.',
    advancedFilterBuilderTitle: 'Продвинутый фильтр',
    advancedFilterBuilderApply: 'Применить',
    advancedFilterBuilderCancel: 'Отмена',
    advancedFilterBuilderAddButtonTooltip: 'Добавить фильтр или группу',
    advancedFilterBuilderRemoveButtonTooltip: 'Удалить',
    advancedFilterBuilderMoveUpButtonTooltip: 'Переместить вверх',
    advancedFilterBuilderMoveDownButtonTooltip: 'Переместить вниз',
    advancedFilterBuilderAddJoin: 'Добавить группу',
    advancedFilterBuilderAddCondition: 'Добавить фильтр',
    advancedFilterBuilderSelectColumn: 'Выберите столбец',
    advancedFilterBuilderSelectOption: 'Выберите параметр',
    advancedFilterBuilderEnterValue: 'Введите значение...',
    advancedFilterBuilderValidationAlreadyApplied: 'Текущий фильтр уже применен.',
    advancedFilterBuilderValidationIncomplete: 'Не все условия завершены.',
    advancedFilterBuilderValidationSelectColumn: 'Необходимо выбрать столбец.',
    advancedFilterBuilderValidationSelectOption: 'Необходимо выбрать параметр.',
    advancedFilterBuilderValidationEnterValue: 'Необходимо ввести значение.',

    // Боковая панель
    columns: 'Столбцы',
    filters: 'Фильтры',

    // Панель инструментов столбцов
    pivotMode: 'Режим сводной таблицы',
    groups: 'Группы строк',
    rowGroupColumnsEmptyMessage: 'Перетащите сюда для группировки по строкам',
    values: 'Значения',
    valueColumnsEmptyMessage: 'Перетащите сюда для агрегации',
    pivots: 'Метки столбцов',
    pivotColumnsEmptyMessage: 'Перетащите сюда для задания заголовков столбцам',

    // Заголовок группового столбца по умолчанию
    group: 'Группа',

    // Перетаскивание строк
    rowDragRow: 'строка',
    rowDragRows: 'строки',

    // Другое
    loadingOoo: 'Загрузка...',
    loadingError: 'Ошибка',
    noRowsToShow: 'Нет данных',
    enabled: 'Включено',

    // Меню
    pinColumn: 'Закрепить столбец',
    pinLeft: 'Закрепить слева',
    pinRight: 'Закрепить справа',
    noPin: 'Не закреплять',
    valueAggregation: 'Агрегация значений',
    noAggregation: 'Нет',
    autosizeThisColumn: 'Авторазмер этого столбца',
    autosizeAllColumns: 'Авторазмер всех столбцов',
    groupBy: 'Группировать по',
    ungroupBy: 'Разгруппировать по',
    ungroupAll: 'Разгруппировать все',
    addToValues: 'Добавить ${variable} в значения',
    removeFromValues: 'Удалить ${variable} из значений',
    addToLabels: 'Добавить ${variable} в метки',
    removeFromLabels: 'Удалить ${variable} из меток',
    resetColumns: 'Сбросить столбцы',
    expandAll: 'Развернуть все группы строк',
    collapseAll: 'Свернуть все группы строк',
    copy: 'Копировать',
    ctrlC: 'Ctrl+C',
    ctrlX: 'Ctrl+X',
    copyWithHeaders: 'Копировать с заголовками',
    copyWithGroupHeaders: 'Копировать с групповыми заголовками',
    cut: 'Вырезать',
    paste: 'Вставить',
    ctrlV: 'Ctrl+V',
    export: 'Экспорт',
    csvExport: 'Экспорт CSV',
    excelExport: 'Экспорт Excel',
    columnFilter: 'Фильтр столбца',
    columnChooser: 'Выбор столбцов',
    chooseColumns: 'Выберите столбцы',
    sortAscending: 'Сортировать по возрастанию',
    sortDescending: 'Сортировать по убыванию',
    sortUnSort: 'Очистить сортировку',

    // Агрегация и строка состояния (Enterprise Menu)
    sum: 'Сумма',
    first: 'Первый',
    last: 'Последний',
    min: 'Минимум',
    max: 'Максимум',
    none: 'Пусто',
    count: 'Количество',
    avg: 'Среднее',
    filteredRows: 'Отфильтрованные',
    selectedRows: 'Выбрано',
    totalRows: 'Всего строк',
    totalAndFilteredRows: 'Строки',
    more: 'Еще',
    to: 'по',
    of: 'из',
    page: 'Страница',
    pageLastRowUnknown: '?',
    nextPage: 'Следующая страница',
    lastPage: 'Последняя страница',
    firstPage: 'Первая страница',
    previousPage: 'Предыдущая страница',
    pageSizeSelectorLabel: 'Размер страницы:',
    footerTotal: 'Итого',

    // Сводные таблицы
    pivotColumnGroupTotals: 'Всего',

    // Меню диаграмм (Enterprise)
    pivotChartAndPivotMode: 'Сводная диаграмма и режим сводки',
    pivotChart: 'Сводная диаграмма',
    chartRange: 'Диапазон диаграммы',

    columnChart: 'Столбчатая',
    groupedColumn: 'Группированная',
    stackedColumn: 'Сложенная',
    normalizedColumn: '100% сложенная',

    barChart: 'Гистограмма',
    groupedBar: 'Группированная',
    stackedBar: 'Сложенная',
    normalizedBar: '100% сложенная',

    pieChart: 'Круговая',
    pie: 'Круговая',
    donut: 'Кольцевая',

    lineChart: 'Линейная',
    stackedLine: 'Сложенная',
    normalizedLine: '100% сложенная',

    xyChart: 'XY (Точечная)',
    scatter: 'Точечная',
    bubble: 'Пузырьковая',

    areaChart: 'Область',
    area: 'Диаграмма с областями',
    stackedArea: 'Сложенная',
    normalizedArea: '100% сложенная',

    histogramChart: 'Гистограмма',

    polarChart: 'Полярная',
    radarLine: 'Радарная линия',
    radarArea: 'Радарная область',
    nightingale: 'Диаграмма Найтинга́йл',
    radialColumn: 'Радиальная колонка',
    radialBar: 'Радиальная гистограмма',

    statisticalChart: 'Статистическая',
    boxPlot: 'Ящичный график',
    rangeBar: 'Диапазонная гистограмма',
    rangeArea: 'Диапазонная область',

    hierarchicalChart: 'Иерархическая',
    treemap: 'Древовидная карта',
    sunburst: 'Солнечная диаграмма',

    specializedChart: 'Специализированная',
    waterfall: 'Водопадная',
    heatmap: 'Тепловая карта',

    combinationChart: 'Комбинированная',
    columnLineCombo: 'Столбчатая и линейная',
    AreaColumnCombo: 'Площадная и столбчатая',

    // Диаграммы
    pivotChartTitle: 'Сводная диаграмма',
    rangeChartTitle: 'График диапазона',
    settings: 'Настройки',
    data: 'Данные',
    format: 'Формат',
    categories: 'Категории',
    defaultCategory: '(Пусто)',
    series: 'Серии',
    switchCategorySeries: 'Переключить категорию / ряд',
    categoryValues: 'Значения категорий',
    seriesLabels: 'Метки рядов',
    aggregate: 'Агрегация',
    xyValues: 'Значения X Y',
    paired: 'Парный режим',
    axis: 'Ось',
    xAxis: 'Горизонтальная ось',
    yAxis: 'Вертикальная ось',
    polarAxis: 'Полярная ось',
    radiusAxis: 'Ось радиуса',
    navigator: 'Навигатор',
    zoom: 'Масштаб',
    animation: 'Анимация',
    crosshair: 'Перекрестие',
    color: 'Цвет',
    thickness: 'Толщина',
    preferredLength: 'Предпочитаемая длина',
    xType: 'Тип X',
    axisType: 'Тип оси',
    automatic: 'Автоматически',
    category: 'Категория',
    number: 'Число',
    time: 'Время',
    timeFormat: 'Формат времени',
    autoRotate: 'Автоповорот',
	xRotation: 'X Поворот',
	yRotation: 'Y Поворот',
    labelRotation: 'Вращение',
    circle: 'Круг',
    polygon: 'Многоугольник',
    square: 'Квадрат',
    cross: 'Крест',
    diamond: 'Ромб',
    plus: 'Плюс',
    triangle: 'Треугольник',
    heart: 'Сердце',
    orientation: 'Ориентация',
    fixed: 'Фиксированная',
    parallel: 'Параллельная',
    perpendicular: 'Перпендикулярная',
    radiusAxisPosition: 'Позиция',
    ticks: 'Отметки',
    gridLines: 'Линии сетки',
    width: 'Ширина',
    height: 'Высота',
    length: 'Длина',
    padding: 'Внутренний отступ',
    spacing: 'Отступ',
	chart: 'Диаграмма',
    chartStyle: 'Стиль диаграммы',
    title: 'Заголовок',
    chartTitles: 'Заголовки',
    chartTitle: 'Заголовок диаграммы',
    chartSubtitle: 'Подзаголовок',
    horizontalAxisTitle: 'Заголовок горизонтальной оси',
    verticalAxisTitle: 'Заголовок вертикальной оси',
    polarAxisTitle: 'Заголовок полярной оси',
    titlePlaceholder: 'Заголовок диаграммы - двойной щелчок для редактирования',
    background: 'Фон',
    font: 'Шрифт',
    weight: 'Толщина',
    top: 'Верх',
    right: 'Право',
    bottom: 'Низ',
    left: 'Лево',
    labels: 'Метки',
    calloutLabels: 'Выноски',
    sectorLabels: 'Метки секторов',
    positionRatio: 'Коэффициент положения',
    size: 'Размер',
    shape: 'Форма',
    minSize: 'Минимальный размер',
    maxSize: 'Максимальный размер',
    legend: 'Легенда',
    position: 'Позиция',
    markerSize: 'Размер маркера',
    markerStroke: 'Обводка маркера',
    markerPadding: 'Отступ маркера',
    itemSpacing: 'Расстояние между элементами',
    itemPaddingX: 'Горизонтальный отступ элемента по X',
    itemPaddingY: 'Вертикальный отступ элемента по Y',
    layoutHorizontalSpacing: 'Горизонтальный отступ',
    layoutVerticalSpacing: 'Вертикальный отступ',
    strokeWidth: 'Толщина линии',
    offset: 'Смещение',
    offsets: 'Смещения',
    tooltips: 'Подсказки',
    callout: 'Выноска',
    markers: 'Маркеры',
    shadow: 'Тень',
    blur: 'Размытие',
    xOffset: 'Смещение по X',
    yOffset: 'Смещение по Y',
    lineWidth: 'Ширина линии',
    lineDash: 'Тип линии',
    lineDashOffset: 'Смещение штрихов',
    scrollingZoom: 'Прокрутка',
    scrollingStep: 'Шаг прокрутки',
    selectingZoom: 'Выделение',
    durationMillis: 'Длительность (мс)',
    crosshairLabel: 'Метка перекрестия',
    crosshairSnap: 'Привязка к узлу',
    normal: 'Обычный',
    bold: 'Жирный',
    italic: 'Курсив',
    boldItalic: 'Жирный курсив',
    predefined: 'Предопределенный',
    fillOpacity: 'Непрозрачность заливки',
    strokeColor: 'Цвет линии',
    strokeOpacity: 'Непрозрачность линии',
    miniChart: 'Мини-диаграмма',
    histogramBinCount: 'Количество корзин',
    connectorLine: 'Соединительная линия',
    seriesItems: 'Элементы серии',
    seriesItemType: 'Тип элемента',
    seriesItemPositive: 'Положительный',
    seriesItemNegative: 'Отрицательный',
    seriesItemLabels: 'Метки элементов',
    columnGroup: 'Столбцы',
    barGroup: 'Гистограмма',
    pieGroup: 'Круговая',
    lineGroup: 'Линейная',
    scatterGroup: 'Точечная',
    areaGroup: 'Площадная',
    polarGroup: 'Полярная',
    statisticalGroup: 'Статистическая',
    hierarchicalGroup: 'Иерархическая',
    specializedGroup: 'Специализированная',
    combinationGroup: 'Комбинированная',
    groupedColumnTooltip: 'Группированная',
    stackedColumnTooltip: 'Сложенная',
    normalizedColumnTooltip: '100% сложенная',
    groupedBarTooltip: 'Группированная',
    stackedBarTooltip: 'Сложенная',
    normalizedBarTooltip: '100% сложенная',
    pieTooltip: 'Круговая',
    donutTooltip: 'Кольцевая',
    lineTooltip: 'Линейная',
    stackedLineTooltip: 'Сложенная',
    normalizedLineTooltip: '100% сложенная',
    groupedAreaTooltip: 'Площадная',
    stackedAreaTooltip: 'Сложенная',
    normalizedAreaTooltip: '100% сложенная',
    scatterTooltip: 'Точечная',
    bubbleTooltip: 'Пузырьковая',
    histogramTooltip: 'Гистограмма',
    radialColumnTooltip: 'Радиальная колонка',
    radialBarTooltip: 'Радиальная гистограмма',
    radarLineTooltip: 'Радарная линия',
    radarAreaTooltip: 'Радарная область',
    nightingaleTooltip: 'Диаграмма Найтинга́йл',
    rangeBarTooltip: 'Диапазонная гистограмма',
    rangeAreaTooltip: 'Диапазонная область',
    boxPlotTooltip: 'Ящичный график',
    treemapTooltip: 'Древовидная карта',
    sunburstTooltip: 'Солнечная диаграмма',
    waterfallTooltip: 'Водопадная диаграмма',
    heatmapTooltip: 'Тепловая карта',
    columnLineComboTooltip: 'Столбчатая и линейная',
    areaColumnComboTooltip: 'Площадная и столбчатая',
    customComboTooltip: 'Настраиваемая комбинация',
    innerRadius: 'Внутренний радиус',
    startAngle: 'Начальный угол',
    endAngle: 'Конечный угол',
    reverseDirection: 'Обратное направление',
    groupPadding: 'Отступ группы',
    seriesPadding: 'Отступ ряда',
    tile: 'Плитка',
    whisker: 'Усы',
    cap: 'Крышка',
    capLengthRatio: 'Соотношение длины',
    labelPlacement: 'Размещение метки',
    inside: 'Внутри',
    outside: 'Снаружи',
    noDataToChart: 'Нет данных для построения диаграммы.',
    pivotChartRequiresPivotMode: 'Для сводной диаграммы необходим режим сводной диаграммы.',
    chartSettingsToolbarTooltip: 'Меню',
    chartLinkToolbarTooltip: 'Связано с таблицей',
    chartUnlinkToolbarTooltip: 'Отключено от таблицы',
    chartDownloadToolbarTooltip: 'Скачать диаграмму',
    chartMenuToolbarTooltip: 'Меню',
    chartEdit: 'Редактировать диаграмму',
    chartAdvancedSettings: 'Расширенные настройки',
    chartLink: 'Связать с таблицей',
    chartUnlink: 'Отключить от таблицы',
    chartDownload: 'Скачать диаграмму',
    histogramFrequency: 'Частота',
    seriesChartType: 'Тип диаграммы ряда',
    seriesType: 'Тип ряда',
    secondaryAxis: 'Вторая ось',
    seriesAdd: 'Добавить ряд',
    categoryAdd: 'Добавить категорию',
    bar: 'Гистограмма',
    column: 'Столбцы',
    histogram: 'Гистограмма',
    advancedSettings: 'Расширенные настройки',
    direction: 'Направление',
    horizontal: 'Горизонтальное',
    vertical: 'Вертикальное',
    seriesGroupType: 'Тип группы',
    groupedSeriesGroupType: 'Группированная',
    stackedSeriesGroupType: 'Сложенная',
    normalizedSeriesGroupType: '100% сложенная',
    legendEnabled: 'Включена',
    invalidColor: 'Некорректный цвет',
    groupedColumnFull: 'Группированная столбчатая',
    stackedColumnFull: 'Сложенная столбчатая',
    normalizedColumnFull: '100% сложенная столбчатая',
    groupedBarFull: 'Группированная гистограмма',
    stackedBarFull: 'Сложенная гистограмма',
    normalizedBarFull: '100% сложенная гистограмма',
    stackedAreaFull: 'Сложенная площадная',
    normalizedAreaFull: '100% сложенная площадная',
    customCombo: 'Настраиваемая комбинация',
    funnel: 'Воронка',
    coneFunnel: 'Конусная воронка',
    pyramid: 'Пирамида',
    funnelGroup: 'Воронка',
    funnelTooltip: 'Воронка',
    coneFunnelTooltip: 'Конусная воронка',
    pyramidTooltip: 'Пирамида',
    dropOff: 'Отказ',
    stageLabels: 'Метки этапов',
    reverse: 'Обратное направление',

    // ARIA
    ariaAdvancedFilterBuilderItem: '${variable}. Уровень ${variable}. Нажмите ENTER для редактирования',
    ariaAdvancedFilterBuilderItemValidation: '${variable}. Уровень ${variable}. ${variable} Нажмите ENTER для редактирования',
    ariaAdvancedFilterBuilderList: 'Список конструктора продвинутого фильтра',
    ariaAdvancedFilterBuilderFilterItem: 'Условие фильтра',
    ariaAdvancedFilterBuilderGroupItem: 'Группа фильтров',
    ariaAdvancedFilterBuilderColumn: 'Столбец',
    ariaAdvancedFilterBuilderOption: 'Опция',
    ariaAdvancedFilterBuilderValueP: 'Значение',
    ariaAdvancedFilterBuilderJoinOperator: 'Оператор объединения',
    ariaAdvancedFilterInput: 'Поле ввода продвинутого фильтра',
    ariaChecked: 'выбрано',
    ariaColumn: 'Столбец',
    ariaColumnGroup: 'Группа столбцов',
    ariaColumnFiltered: 'Столбец отфильтрован',
    ariaColumnSelectAll: 'Переключить видимость всех столбцов',
    ariaDateFilterInput: 'Поле ввода фильтра даты',
    ariaDefaultListName: 'Список',
    ariaFilterColumnsInput: 'Поле ввода для фильтрации столбцов',
    ariaFilterFromValue: 'Фильтр от значения',
    ariaFilterInput: 'Поле ввода фильтра',
    ariaFilterList: 'Список фильтров',
    ariaFilterToValue: 'Фильтр до значения',
    ariaFilterValue: 'Значение фильтра',
    ariaFilterMenuOpen: 'Открыть меню фильтра',
    ariaFilteringOperator: 'Оператор фильтрации',
    ariaHidden: 'скрыто',
    ariaIndeterminate: 'неопределено',
    ariaInputEditor: 'Редактор ввода',
    ariaMenuColumn: 'Нажмите ALT + ВНИЗ для открытия меню столбца',
    ariaFilterColumn: 'Нажмите CTRL + ENTER для открытия фильтра',
    ariaRowDeselect: 'Нажмите ПРОБЕЛ, чтобы отменить выбор этой строки',
    ariaHeaderSelection: 'Столбец с выбором заголовка',
    ariaSelectAllCells: 'Нажмите ПРОБЕЛ, чтобы выбрать все ячейки',
    ariaRowSelectAll: 'Нажмите ПРОБЕЛ, чтобы переключить выбор всех строк',
    ariaRowToggleSelection: 'Нажмите ПРОБЕЛ, чтобы переключить выбор строки',
    ariaRowSelect: 'Нажмите ПРОБЕЛ, чтобы выбрать эту строку',
    ariaRowSelectionDisabled: 'Выбор строк отключен для этой строки',
    ariaSearch: 'Поиск',
    ariaSortableColumn: 'Нажмите ENTER для сортировки',
    ariaToggleVisibility: 'Нажмите ПРОБЕЛ, чтобы переключить видимость',
    ariaToggleCellValue: 'Нажмите ПРОБЕЛ, чтобы переключить значение ячейки',
    ariaUnchecked: 'не выбрано',
    ariaVisible: 'видимо',
    ariaSearchFilterValues: 'Поиск значений фильтра',
    ariaPageSizeSelectorLabel: 'Размер страницы',
    ariaChartMenuClose: 'Закрыть меню редактирования диаграммы',
    ariaChartSelected: 'Выбрано',
    ariaSkeletonCellLoadingFailed: 'Ошибка загрузки строки',
    ariaSkeletonCellLoading: 'Загрузка данных строки',

    // ARIA Метки для зон перетаскивания
    ariaRowGroupDropZonePanelLabel: 'Группы строк',
    ariaValuesDropZonePanelLabel: 'Значения',
    ariaPivotDropZonePanelLabel: 'Метки столбцов',
    ariaDropZoneColumnComponentDescription: 'Нажмите DELETE, чтобы удалить',
    ariaDropZoneColumnValueItemDescription: 'Нажмите ENTER, чтобы изменить тип агрегации',
    ariaDropZoneColumnGroupItemDescription: 'Нажмите ENTER для сортировки',
    // используется для зоны агрегации, формат: {aggregation}{ariaDropZoneColumnComponentAggFuncSeparator}{column name}
    ariaDropZoneColumnComponentAggFuncSeparator: ' из ',
    ariaDropZoneColumnComponentSortAscending: 'по возрастанию',
    ariaDropZoneColumnComponentSortDescending: 'по убыванию',

    ariaLabelDialog: 'Диалог',

    ariaLabelColumnMenu: 'Меню столбцов',
    ariaLabelColumnFilter: 'Фильтр столбцов',

    ariaLabelCellEditor: 'Редактор ячеек',
    ariaLabelSelectField: 'Выбрать поле',

    // ARIA метки для асинхронных контекстных меню
    ariaLabelLoadingContextMenu: 'Загрузка контекстного меню',

    // ARIA метки для расширенного выбора
    ariaLabelRichSelectField: 'Поле расширенного выбора',
    ariaLabelRichSelectToggleSelection: 'Нажмите ПРОБЕЛ, чтобы переключить выбор',
    ariaLabelRichSelectDeselectAllItems: 'Нажмите DELETE, чтобы снять выделение со всех элементов',
    ariaLabelRichSelectDeleteSelection: 'Нажмите DELETE, чтобы снять выделение с элемента',

    ariaLabelTooltip: 'Подсказка',
    ariaLabelContextMenu: 'Контекстное меню',
    ariaLabelSubMenu: 'Подменю',
    ariaLabelAggregationFunction: 'Функция агрегации',
    ariaLabelAdvancedFilterAutocomplete: 'Автозаполнение продвинутого фильтра',
    ariaLabelAdvancedFilterBuilderAddField: 'Конструктор продвинутого фильтра - добавить поле',
    ariaLabelAdvancedFilterBuilderColumnSelectField: 'Конструктор продвинутого фильтра - выбор столбца',
    ariaLabelAdvancedFilterBuilderOptionSelectField: 'Конструктор продвинутого фильтра - выбор опции',
    ariaLabelAdvancedFilterBuilderJoinSelectField: 'Конструктор продвинутого фильтра - выбор оператора объединения',

    // ARIA Метки для боковой панели
    ariaColumnPanelList: 'Список столбцов',
    ariaFilterPanelList: 'Список фильтров',

    // Формат чисел (Строка состояния, панель навигации)
    thousandSeparator: ',',
    decimalSeparator: '.',

    // Типы данных
    true: 'Истина',
    false: 'Ложь',
    invalidDate: 'Недействительная дата',
    invalidNumber: 'Недействительное число',
    january: 'Январь',
    february: 'Февраль',
    march: 'Март',
    april: 'Апрель',
    may: 'Май',
    june: 'Июнь',
    july: 'Июль',
    august: 'Август',
    september: 'Сентябрь',
    october: 'Октябрь',
    november: 'Ноябрь',
    december: 'Декабрь',

    // Time formats
    timeFormatSlashesDDMMYYYY: 'DD/MM/YYYY',
    timeFormatSlashesMMDDYYYY: 'MM/DD/YYYY',
    timeFormatSlashesDDMMYY: 'DD/MM/YY',
    timeFormatSlashesMMDDYY: 'MM/DD/YY',
    timeFormatDotsDDMYY: 'DD.M.YY',
    timeFormatDotsMDDYY: 'M.DD.YY',
    timeFormatDashesYYYYMMDD: 'YYYY-MM-DD',
    timeFormatSpacesDDMMMMYYYY: 'DD MMMM YYYY',
    timeFormatHHMMSS: 'HH:MM:SS',
    timeFormatHHMMSSAmPm: 'HH:MM:SS AM/PM',
};
